import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Partner_Service_URL } from "../Url";

export const getVerificationMasterAction = {
  GET_VERIFICATION_MASTER_DETAILS_SUCCESS:
    "GET_VERIFICATION_MASTER_DETAILS_SUCCESS",
  GET_VERIFICATION_MASTER_DETAILS_ERROR:
    "GET_VERIFICATION_MASTER_DETAILS_ERROR",
};

export function getVerifactionMasterDetails(props) {
  const accessToken = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/get/partnerVerificationInfoMasters`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getVerificationMasterSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getVerificationMasterError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getVerificationMasterError(err));
          return err;
        }
      });
}

export function getVerificationMasterError(error) {
  return {
    type: getVerificationMasterAction.GET_VERIFICATION_MASTER_DETAILS_ERROR,
    payload: error,
  };
}

export function getVerificationMasterSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getVerificationMasterAction.GET_VERIFICATION_MASTER_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export const getVerificationDataAction = {
  GET_VERIFICATION_ALL_DETAILS_SUCCESS: "GET_VERIFICATION_ALL_DETAILS_SUCCESS",
  GET_VERIFICATION_ALL_DETAILS_ERROR: "GET_VERIFICATION_ALL_DETAILS_ERROR",
};

export function getVerifactionAllDetails(accessToken, partnerFrimID) {
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/getPartnerVerificationInfo?partnerFirmId=${partnerFrimID}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getVerificationAllDataSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getVerificationAllDataError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getVerificationAllDataError(err));
          return err.response;
        }
      });
}

export function getVerificationAllDataError(error) {
  return {
    type: getVerificationDataAction.GET_VERIFICATION_ALL_DETAILS_ERROR,
    payload: error,
  };
}

export function getVerificationAllDataSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getVerificationDataAction.GET_VERIFICATION_ALL_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export const getRejectDataAction = {
  GET_REJECT_DETAILS_SUCCESS: "GET_REJECT_DETAILS_SUCCESS",
  GET_REJECT_DETAILS_ERROR: "GET_REJECT_DETAILS_ERROR",
};

export function getRejectAllDetails(accessToken, partnerFrimID) {
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/getRejectedPartnerVerificationInfo?partnerFirmId=${partnerFrimID}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getRejectAllDataSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getRejectAllDataError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getRejectAllDataError(err));
          return err.response;
        }
      });
}

export function getRejectAllDataError(error) {
  return {
    type: getRejectDataAction.GET_REJECT_DETAILS_ERROR,
    payload: error,
  };
}

export function getRejectAllDataSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getRejectDataAction.GET_REJECT_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
